import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { useTranslation } from "@redotech/redo-i18n";
import ArrowLeft from "@redotech/redo-icons/arrow-left.svg";

export function NavigationHeader({
  previousClicked,
  previousButtonDisabled = false,
  headerRight,
}: {
  previousClicked: () => void;
  previousButtonDisabled?: boolean;
  headerRight?: React.ReactNode;
}) {
  const { t } = useTranslation();

  return (
    <Flex justify="space-between" p="none">
      <RedoButton
        aria-label={t("Go back")}
        centerItems={false}
        dataTestId="back-button"
        disabled={previousButtonDisabled}
        hierarchy="link"
        IconLeading={ArrowLeft}
        onClick={previousClicked}
        size="lg"
        uiSelector="back-button"
      />
      {headerRight}
    </Flex>
  );
}
